<template>
  <div>

        <md-table v-model="negatori" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Ime">{{ item.negator_ime_naziv }}</md-table-cell>
        <md-table-cell md-label="Država">{{ item.negator_drzava }}</md-table-cell>
        <md-table-cell md-label="Opis">{{ item.negator_opis.substring(0,36) }}<p v-if="item.negator_opis.length > 35">...</p></md-table-cell>
        <md-table-cell md-label="Oblast">{{ item.negator_oblast }}</md-table-cell>
        <md-table-cell md-label="">
            <router-link :to="'/editnegator/'+item.uuid_negator">Izmijeniti</router-link>
        </md-table-cell>        
      </md-table-row>
    </md-table>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "cisti-negatori",
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  methods:{
  },
  data() {
    return {
      selected: [],
      httpOptions: "",
      negatori: []
    }
  },
  components: {
    
  },
  mounted: async function(){
      const token = await this.$auth.getTokenSilently()
       axios.get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/negatori",
       {headers:{Authorization: `Bearer ${token}`}})
      .then(((response) => {
          this.negatori = response.data['Items']
        })) 
  },
  updated: function()
  {
  }
};
</script>
